__webpack_require__.p = "/voos/";